import {
    Component, ElementRef, EventEmitter, HostListener, Inject, Input, Output, Renderer2, ViewChild
} from '@angular/core';


import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';




export interface HooksDataTable {
    modelName: string;
    actionName: string;
    eventName: string;
    stepName: string;
    envTypes: string;
    failJob: string,
    loginUser: string;
    timeout: string;
    batchFileName: string;
    id: number
}

@Component({
    selector: 'hooks-data',
    template: require('./hooks-data.component.html'),
    styles: [require('./hooks-data.component.scss')]
})


export class HooksDataComponent {
    public projectId: any;
    public environmentId: string;
    @Output() public deleteItem = new EventEmitter();
    public get data() {
        return this._data;
    }

    @Input() public set data(value) {
        if (value) {
            this._data = value;
            const data = [];
            value.forEach((hook) => {
                data.push({
                    modelName: hook.modelName,
                    actionName: hook.actionName,
                    eventName: hook.events.join(', '),
                    stepName: hook.step.join(', '),
                    envTypes: hook.envTypes.join(', '),
                    failJob: hook.failJobOnFailure,
                    loginUser: hook.loginUser == null ? "" : hook.loginUser,
                    timeout: hook.timeout,
                    batchFileName: hook.additionalOption.find(option => option.name === 'BatchFile').value,
                    id: hook.id

                });
            });
            this.dataSource.data = data;
        }
    }
    // tslint:disable-next-line:variable-name
    private _data: any;

    public displayedColumns = ['eventName', 'stepName', 'modelName', 'actionName', 'envTypes', 'failJob', 'loginUser', 'timeout', 'batchFileName', 'delete'];
    public dataSource = new MatTableDataSource<HooksDataTable>([]);
    @ViewChild(MatSort) public sort: MatSort;

    private pressed = false;
    private currentResizeIndex: number;
    private startX: number;
    private startWidth: number;
    private isResizingRight: boolean;
    private resizableMousemove: () => void;
    private resizableMouseup: () => void;

    @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
    private columns: any[] = [
        { field: 'eventName' },
        { field: 'stepName' },
        { field: 'modelName' },
        { field: 'actionName' },
        { field: 'envTypes' },
        { field: 'failJob' },
        { field: 'loginUser' },
        { field: 'timeout' },
        { field: 'batchFileName' },
        { field: 'delete' },
    ];

    constructor(

        @Inject('$stateParams') stateParams: any,
        private renderer: Renderer2,

    ) {
        this.projectId = stateParams.id;
        this.environmentId = stateParams.envID;

    }


    deleteHook = (id) => {
        this.deleteItem.emit({ id: id })

    }



    public async ngOnInit() {

    }


    private setTableResize() {
        // Allow table to use auto-layout for optimal column widths
    }

    public onResizeColumn(event: any, index: number) {
        // Initialize column widths from actual rendered widths on first resize
        this.columns.forEach((col, i) => {
            if (!col.width) {
                const cellData = this.getCellData(i);
                col.width = cellData.width;
            }
        });

        this.checkResizing(event, index);
        this.currentResizeIndex = index;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = event.target.clientWidth;
        event.preventDefault();
        this.mouseMove(index);
    }




    private checkResizing(event, index) {
        const cellData = this.getCellData(index);
        if ((index === 0) ||
            (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
            this.isResizingRight = true;
        } else {
            this.isResizingRight = false;
        }
    }

    private getCellData(index: number) {
        const headerRow = this.matTableRef.nativeElement.children[0];
        const cell = headerRow.children[0].children[index];
        return cell.getBoundingClientRect();
    }

    private mouseMove(index: number) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons) {
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
                if (this.currentResizeIndex === index && width > 50) {
                    this.setColumnWidthChanges(index, width);
                }
            }
        });


        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
                this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }

    private setColumnWidthChanges(index: number, width: number) {
        const orgWidth = this.columns[index].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const j = (this.isResizingRight) ? index + 1 : index - 1;
            const newWidth = this.columns[j].width - dx;
            if (newWidth > 50) {
                this.columns[index].width = width;
                this.setColumnWidth(this.columns[index]);
                this.columns[j].width = newWidth;
                this.setColumnWidth(this.columns[j]);
            }
        }
    }

    private setColumnWidth(column: any) {
        // Only set explicit width if column has width defined (for manual resizing)
        if (column.width) {
            const columnEls = Array.from(document.getElementsByClassName(`mat-column-${column.field}`));
            columnEls.forEach((el: HTMLDivElement) => {
                const packageNameElement = Array.from(el.getElementsByClassName('dp-package-name'));
                if (packageNameElement && packageNameElement.length > 0) {
                    const el1: HTMLElement = packageNameElement[0] as HTMLElement;
                    el1.style.width = `${column.width}px`;
                }
                el.style.width = `${column.width}px`;
            });
        }
    }

    @HostListener('window:resize', ['$event'])
    public onResize() {
        this.setTableResize();
    }


    public getTagsName(tags: any): string {
        return tags.map(t => t.displayName).join(',');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/hooks-ang7/hooks-data/hooks-data.component.ts